import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL, PANEl_BASE_URL } from '@app/contstants/endpoints';
import { IAccount } from '@entities/account/IAccount';

export const fetch = async (id: string): Promise<IAccount> => {
  const account = await api.get<any>(`${PANEl_BASE_URL}/accounts/accounts/${id}/`);
  const accountInfo = await api.get<any>(`${BI_BASE_URL}/accounts/${id}/info`);
  let data = account.data ?? [];

  data = {
    ...data,
    managers: data.managers.map((manager: any) => ({
      value: manager.id,
      label: manager.label,
    })),
    client:
      data.client.id !== undefined ? { value: data.client.id, label: data.client.label } : null,
    tags: data?.tags ? { value: data?.tags, label: data?.tags } : null,
    source: data?.source ? { value: data?.source, label: data?.source } : null,
    ...accountInfo.data,
  };

  return data;
};

export const useAccount = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
